import React, { useRef, useState } from "react";
import { SuccessAlert, ErrorAlert } from "./../Alert";
import emailjs from "@emailjs/browser";

function Contact() {
  const inputRef = useRef(null);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [message, setMessage] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_ai1bv4r",
        "template_dkeer58",
        inputRef.current,
        "0jXs3a9J860XwIeTC"
      )
      .then(
        (result) => {
          console.log(result.text);
          setMessage("Message Sent Successfully!");
          setSuccess(true);
        },
        (error) => {
          // console.log(error.text);
          setMessage("Oops! There was an error");
          setError(true);
        }
      );
    //console.log(inputRef.current);
  };
  return (
    <section className="section-6" id="contact-section">
      <div className="row">
        <h2>Get In Touch</h2>
        {success && <SuccessAlert message={message} />}
        {error && <ErrorAlert message={message} />}
        <div className="column-area">
          <div className="content" data-aos="fade-right">
            <h4>Let's talk about everything!</h4>
          </div>
          <form
            action=""
            ref={inputRef}
            onSubmit={handleSubmit}
            data-aos="fade-left"
          >
            <input
              type="text"
              name="user_name"
              placeholder="Your name"
              required
            />
            <input
              type="email"
              placeholder="Email address"
              name="user_email"
              id=""
              required
            />
            <input
              type="text"
              name="user_subject"
              placeholder="subject"
              required
            />
            <textarea
              name="user_message"
              id=""
              cols="30"
              rows="10"
              placeholder="message"
              required
            ></textarea>
            <button type="submit" id="">
              Send Message
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}

export default Contact;
